import { Quantity } from "../math";
import { IsSize3 } from "./geometry.interfaces";
export class Size2 {
    static ConvertInPlace(size, from, to) {
        return Size2.ConvertToRef(size, from, to, size);
    }
    static ConvertToRef(size, from, to, ref) {
        ref = ref ?? Size2.Zero();
        ref.width = Quantity.Convert(size.width, from, to);
        ref.height = Quantity.Convert(size.height, from, to);
        return ref;
    }
    static Zero() {
        return new Size2(0, 0);
    }
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
    multiplyFloats(w, h) {
        return new Size2(this.width * w, this.height * (h ?? w));
    }
    clone() {
        return new Size2(this.width, this.height);
    }
    equals(other) {
        return this.height === other.height && this.width === other.width;
    }
}
export class Size3 extends Size2 {
    static ConvertInPlace(size, from, to) {
        return Size3.ConvertToRef(size, from, to, size);
    }
    static ConvertToRef(size, from, to, ref) {
        ref = ref ?? Size3.Zero();
        ref.width = Quantity.Convert(size.width, from, to);
        ref.height = Quantity.Convert(size.height, from, to);
        ref.depth = Quantity.Convert(size.depth, from, to);
        return ref;
    }
    static Zero() {
        return new Size3(0, 0, 0);
    }
    static IsEmpty(size) {
        return size.width === 0 && size.height === 0 && (size.depth ?? 0) === 0;
    }
    static FromSize(size) {
        if (IsSize3(size)) {
            return new Size3(size.width, size.height, size.depth);
        }
        return new Size3(size.width, size.height);
    }
    constructor(width, height, depth = 0) {
        super(width, height);
        this.depth = depth;
    }
    get hasThickness() {
        return this.depth !== undefined;
    }
    clone() {
        return new Size3(this.width, this.height, this.depth);
    }
    equals(other) {
        return this.height === other.height && this.width === other.width && this.depth === other.depth;
    }
}
//# sourceMappingURL=geometry.size.js.map